import {css, Theme} from "@emotion/react";
import {borderRadius, flex, p} from "@pg-design/helpers-css";
import {Pill} from "@pg-design/pill";
import {Text} from "@pg-design/text";

import {flexGap} from "../../../../../components/css_helpers/flex";
import {SubscriptionPeriod} from "./subscription_modal.constants";

interface ISubscriptionPeriodPillsProps {
    selectedPeriod: SubscriptionPeriod;
    onChange: (period: SubscriptionPeriod) => void;
    monthlyLabel: string;
    yearlyLabel: string;
}

const PERIOD_OPTIONS: SubscriptionPeriod[] = ["monthly", "annually"];

export const SubscriptionPeriodPills = ({
    selectedPeriod,
    onChange,
    monthlyLabel,
    yearlyLabel
}: ISubscriptionPeriodPillsProps) => {
    const labels: Record<SubscriptionPeriod, string> = {
        monthly: monthlyLabel,
        annually: yearlyLabel
    };

    return (
        <div css={toggleWrapper}>
            {PERIOD_OPTIONS.map((period) => {
                const isActive = selectedPeriod === period;

                return (
                    <button
                        key={period}
                        type="button"
                        css={optionButton}
                        onClick={() => onChange(period)}
                        aria-pressed={isActive}
                    >
                        <Pill size="small" css={pill(isActive)}>
                            <Text variant="info_txt_1" strong={isActive}>
                                {labels[period]}
                            </Text>
                        </Pill>
                    </button>
                );
            })}
        </div>
    );
};

const toggleWrapper = (theme: Theme) => css`
    ${flex("center", "center")};
    ${flexGap(0.5)};
    ${borderRadius(4)};
    ${p(0.5)};
    background-color: ${theme.colors.gray["100"]};
    width: fit-content;
    margin: 0 auto;
`;

const optionButton = css`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
`;

const pill = (isActive: boolean) => (theme: Theme) => css`
    background-color: ${isActive ? "#fff" : "transparent"} !important;
    box-shadow: ${isActive ? "0 1px 4px rgba(0, 0, 0, 0.08)" : "none"};
    color: ${isActive ? theme.colors.gray["800"] : theme.colors.gray["700"]};
    transition:
        background-color 0.15s ease,
        box-shadow 0.15s ease;
`;
